const centeredFlexColumnStyle = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
};

export default centeredFlexColumnStyle;
